import Axios from 'axios';
import { Message } from "element-ui";
import VM from '@/main';

// 配置默认参数
let instance = Axios.create({
  baseURL: '/api/v2/',
  timeout: 10000,
  headers: {}
});

// 添加请求拦截器
instance.interceptors.request.use(config => {
  const { userInfo } = VM.$store.state;

  if (userInfo) {
    const Authorization = `Bearer ${userInfo.token}`;
    config.headers.Authorization = Authorization;
  }

  const { url } = config;
  url.includes('/api/') && (config.baseURL = '');

  // 判断是否线上环境
  if (process.env.NODE_ENV === "production") {
    if (url.includes('/apiv1/')) {
      config.baseURL = '';
    };
  } else {
    if (url.includes('/apiv1/')) {
      config.baseURL = '/apiv1';
    };
  }

  return config;
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(res => {
  // 请求响应
  const { data, headers } = res;
  const { error } = data;
  if (error == '没有权限，请先登录') {
    return data;
  } else {
    // 如果有新的token，更新token
    if ('authorization' in headers) {
      const token = headers.authorization.replace(/Bearer /, "");
      VM.updateUserInfo({ token });
    }
    // 错误提示
    if (error) {
      const isStr = typeof error === 'string';
      Message.error(isStr ? error : error.toString());
      return Promise.reject(res);
    }
    return data;
  }

}, error => {
  // token失效，指向登录
  const { status } = error.response;
  if (status === 401) {
    const { name } = VM.$route;
    name !== 'login' ? VM.$router.push({ name: 'login' }) : VM.$message.error('账号或密码错误，请检查！');
  }
  console.log("error.response", error.response);
  // 对响应错误做点什么
  return Promise.reject(error);
});
export default {
  install(Vue) {
    Vue.prototype.$axios = instance;
  },
  instance
};
